// extracted by mini-css-extract-plugin
export default {"inputStyles":"pure-radio_inputStyles__beuLK","requiredAsterisk":"pure-radio_requiredAsterisk__-6RwB"};